<template>
  <el-col
    :span="24"
    id="payments"
    v-loading.body="(receiving || changingPage) && !navigating"
    element-loading-text="Fetching page...">
    <el-row type="flex" justify="start" align="middle" id="payments-header">
      <HeaderInfoText :colspan="9" title="PAYMENTS" :meta="meta" :selection="selection"></HeaderInfoText>
      <el-col :span="6">
        <el-row type="flex" justify="center" v-if="meta.count > 20">
          <el-pagination
            layout="prev, pager, next, jumper"
            :total="meta.count"
            :page-size="20"
            @current-change="changePage"
            :current-page="currentPage"
          />
        </el-row>
      </el-col>
      <el-col :span="13" class="h-padded right-aligned-col">
        <el-button
          type="danger"
          plain
          @click="printCopyMethod"
          :disabled="!printableApsSelected || printCopyDisable || !checkingVoid "
          :loading="!!loadingRelated">
          {{  !!loadingRelated ? 'Loading' : 'Print Copy' }}
        </el-button>
        <el-select
            placeholder="Actions"
            v-model="voidUpdateSelection"
            style="padding: 0 6px;"
            @change="handleStatusSelection">
            <el-option label="Void Selected Payments" value='void' :disabled="!selection.length || !selectionIsVoidable"></el-option>
            <el-option label="Delete Selected Payments" value='delete' :disabled="!selection.length || !selectionIsDeletable"></el-option>
            <el-option label="Send Email" value='sendEmail' :disabled="disableSentEmails"></el-option>
        </el-select>
        <el-button plain @click="toggleFilters">
          {{ showFilters ? "Hide filters" : "Show filters" }}
        </el-button>
      </el-col>
    </el-row>
    
    <el-row type="flex" justify="center" align="middle" style="padding: 0 12px;">
      <el-button v-if="showFilters" class="mr-4 vendor-button" @click="onClickVendors">Vendors Selected {{selectedVendors.length ? `(${selectedVendors.length})` : ''}}</el-button>
      <Filters
        :filters="filters"
        :filtersVisible="showFilters"
        :filterSize="4"
        clearAction="clearPaymentState"
        clearMetadataAction="resetPaymentMeta"
        searchAction="fetchPaymentsWithQuery"
        :autoApply="false"
        @doneFiltering="() => { currentPage = 1, resetSelection() }">
        <template v-for="(f, i) in filters" slot-scope="props" :slot="`${f.type}${i}`">
          <component :key="i" :is="f.type" :properties="f.props" />
        </template>
      </Filters>
    </el-row>
    <el-row type="flex" justify="end" align="middle">
      <el-col :span="24">
        <TransactionsConfList v-if="payments" name="payments_transactions_conf_list" ref="payments_conf_list" :aggridColumns="aggridColumns"
        :emitSelect="true" @onSelect="handleSelectionChange" :loadingRelated.sync="loadingRelated" :voidingPayment.sync="voidingPayment" :postingPayment.sync="postingPayment"
          @handleVoidDialogVisible="handleVoidDialogVisible" @postPayment="postPayment"
          :rows="payments" :currentPage="currentPage"/>
        <el-row v-if="!receiving && !meta.count" align="middle" justify="center" class="nodata-heading">
          No data available
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
    title="Report Viewer"
    size="large"
    :show-close="true"
    :close-on-click-modal="true"
    :destroy-on-close="true"
    @close="handleClose"
    @before-close="handleBeforeClose"
    :fullscreen.sync="isFullscreen"
    top="5%"
    :visible.sync="pdfLoader">
    <template v-if="loadPdf">
      <el-row type="flex" align="middle" >
        <object :data="`data:application/pdf;base64,${loadPdf}`" type="application/pdf"  width="1500" height="600" ></object>
    <!-- <iframe
              :src="loadPdf ? `data:application/pdf;base64,${loadPdf}` : ''"
              :allowfullscreen="true"
              width="100%"
              frameborder="0"
            /> -->
          </el-row>
          </template>
        </el-dialog>
    <el-dialog
      :title="modelTitle"
      :visible="!!voidDialogVisible"
      size="large"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-row type="flex" align="middle" justify="start" style="padding: 12px 0;">
        <span>
          {{
            `${typeof voidDialogVisible === 'object' && voidDialogVisible.id ? 'This payment is' : 'These payments are'}
            related to the APs listed below.`
          }}
        </span>
      </el-row>
      <el-row type="flex" align="middle" justify="center">
        <el-col :span="24">
          <el-table
            v-if="relatedTransactions.length"
            id="void-ap-table"
            :data="relatedTransactions"
            border
            style="width: 100%; z-index: 0;"
            ref="voidApTable">
            <el-table-column prop="ledger" label="Ledger ID" align="center" width="100"></el-table-column>
            <el-table-column prop="amount_decimal" label="Amount" align="center" width="120">
              <template slot-scope="scope">
                ${{ scope.row.amount_decimal ? scope.row.amount_decimal : '0.00' }}
              </template>
            </el-table-column>
            <el-table-column prop="vendor" label="Vendor" align="left" fit>
              <template slot-scope="scope">
                {{ getVendorName(scope.row.vendor) || ''}}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row class="h-padded right-aligned-col">
        <el-col :span="24">
          <span style="padding: 12px 15px;"> Do you want to void associated AP{{(relatedTransactions && relatedTransactions.length) > 1 ? 's' : ''}}?</span><span><el-checkbox v-model="void_ap" /></span>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="exit-modal-btn"
          @click="voidDialogVisible = false">
          Cancel
        </el-button>
        <el-button
          class="exit-modal-btn"
          type="primary"
          @click="voidPayments">
          Confirm
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Select Vendors"
      :visible="!!vendorsDialogVisible"
      size="small"
      :show-close="false"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <el-row type="flex" align="middle" justify="center">
        <el-col>
          <div align="center">{{vendorLoading ? 'Loading Vendors...' : ''}}</div>
          <br>
          <el-transfer
            ref="accountTransfer"
            v-model="selectedVendors"
            :data="vendors"
            :titles="[ 'Unselected Vendors', 'Selected Vendors' ]"
            :props="{ key: 'id', label: 'display_name' }"
            filterable
            filter-placeholder="Search Vendor"
          >
          </el-transfer>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="exit-modal-btn"
          type="primary"
          @click="confirmVendors">
          Confirm
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="sendEmailVisible"
      size="large"
      :show-close="true"
      :close-on-press-escape="true"
      @close="closeSendEmailModal">
      <el-row type="flex" align="middle" justify="end" style="border-bottom: 1px solid lightgrey;">
      <HeaderInfoText :colspan="12" title="Send Email" />
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-button type="primary" @click="sendEmailVisible = false" style="margin: 0 15px;">Cancel</el-button>
          <el-button type="primary" @click="sendEmail" style="margin: 0 15px;">Send Email</el-button>
        </el-row>
      </el-col>
    </el-row>
      <nacha-payment-conf-list v-if="sendEmailVisible && selectedPayments" name="nacha_payment_conf_list" ref="nacha_payment_conf_list"
          :allow-edit="true" :allow-notify="step < 4" :width="width" :height="height" :row-data="selectedPayments" @onSelect="handleSelectedConf" @updateCCMail="handleCellUpdate" />
        <el-row v-if="!selectedPayments && !selectedPayments.length" align="middle" justify="center" class="nodata-heading">
          No data available
        </el-row>
    </el-dialog>
  </el-col>
</template>

<script>
  import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import { payload } from '@/components/RouteComponents/Payments/actionPayload'
  import { payload as checksPayload } from '@/components/RouteComponents/Checks/actionPayload'
  import store from '@/store/store'
  import Filters from '@/components/Filters.vue'
  import KeywordFilter from '@/components/FilterComponents/KeywordFilter'
  import SelectFilter from '@/components/FilterComponents/SelectFilter'
  import DateFilter from '@/components/FilterComponents/DateFilter'
  import AutocompleteFilter from '@/components/FilterComponents/AutocompleteFilter'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import { notify } from '@/utils/helpers/Notify'
  import { formatLocale } from '@/utils/helpers/StringsNumbers'
  import { reportMixins } from '@/Mixins/Reports'
  import { sortObjectByProperty } from '@/utils/helpers/ObjectSorting'
  import TransactionsConfList from '@/components/SigmaClientNew/TransactionsConfList.vue'
  import NachaPaymentConfList from '@/components/SigmaClientNew/NachaPaymentConfList.vue'
  import { getHeaders, buildUrlWithQuery } from '@/utils/api'

// import { cloneWith } from 'lodash'
  export default {
    components: {
      Filters,
      KeywordFilter,
      SelectFilter,
      DateFilter,
      AutocompleteFilter,
      HeaderInfoText,
      TransactionsConfList,
      NachaPaymentConfList
    },
    mixins: [ reportMixins ],
    data () {
      return {
        ccMail: {},
        selectedPayments: [],
        sendEmailVisible: false,
        tableHeight: 1000,
        showFilters: true,
        statusValues: [],
        selection: [],
        voidDialogVisible: false,
        relatedTransactions: [],
        changingPage: false,
        postingPayment: null,
        validationModel: null,
        voidingpayment: null,
        loadingRelated: false,
        currentPage: 1,
        voidUpdateSelection: null,
        vendorsDialogVisible: false,
        selectedVendors: [],
        vendors: [],
        vendorLoading: false,
        void_ap: false,
        aggridColumns: ['rowSelect', 'bankColumn', 'dateColumn', 'numberColumn', 'paymentTypeColumn', 'vendorColumn', 'amountColumn', 'isNotifiedColumn', 'actionsColumn'],
        loadPdf: '',
        pdfLoader: false,
        printCopyDisable: false
      }
    },
    methods: {
      closeSendEmailModal () {
        this.sendEmailVisible = false
      },
      resetSelection () {
        this.selection = []
      },
      handleBeforeClose (done) {
        this.loadPdf = null // Clear the PDF data
        done() // Close the dialog
      },
      // method to close the print close PDF.
      handleClose () {
        this.pdfLoader = false
      },
      // method is used to cal API to get Base64 data
      async printCopyMethod () {
        this.loadingRelated = true
        /* eslint-disable camelcase */
        let payment__in = []
        let accountpayable__in = []
        accountpayable__in = this.selection.filter(s => s.payment_type !== 'CHECK' && (s.related_transactions && s.related_transactions.length === 0)).map((ap) => ap.id)
        payment__in = this.selection.filter(s => s.payment_type !== 'CHECK' && (s.related_transactions && s.related_transactions.length > 0)).map((ap) => ap.id)
        // const payments = this.selection.filter(s => s.payment_type !== 'CHECK').map((ap) => ap.id)
        const checks__in = this.selection.filter(s => s.payment_type === 'CHECK').map((ap) => ap.id)
        // const accountsPayable = this.selection.filter(s => s.payment_type === 'CHECK').map((ap) => ap.id)
        // const paymentType = this.selection[0].payment_type
        const newPayload = Object.assign({}, { payment__in, checks__in, accountpayable__in })
        // const resp = await this.$store.dispatch('saveCheckrun', newPayload)
        const resp1 = await this.$store.dispatch('cacheParams', { data: newPayload })
        this.createCheckrunPdf(resp1)
      },
      async createCheckrunPdf (resp) {
        try {
          const bank = this.getBankById(this.selection[0].bank.id)
          let payload = {}
          if (bank && bank.check_preferred_template) {
            let opts = await this.$store.dispatch('fetchOptions', { endpoint: 'reports/checks' })
            if (opts && opts.template_parameter && ['EFT', 'WIRE', 'CHECK', 'CHECK_MANUAL'].includes(this.selection[0].payment_type)) {
              if (this.selection[0].payment_type === 'EFT') {
                payload[opts.template_parameter] = 'payment_receipt_eft'
              } else if (this.selection[0].payment_type === 'WIRE') {
                payload[opts.template_parameter] = 'payment_receipt_wire_transfer'
              } else if (this.selection[0].payment_type === 'CHECK') {
                payload[opts.template_parameter] = 'default'
              } else if (this.selection[0].payment_type === 'CHECK_MANUAL') {
                payload.report_template = 'payment_receipt_manual_check'
              }
            } else {
              if (opts && opts.templates && opts.templates[bank.check_preferred_template]) {
                payload[opts.template_parameter] = bank.check_preferred_template
              }
            }
          } else {
            if (this.selection[0].payment_type === 'EFT') {
              payload.report_template = 'payment_receipt_eft'
            } else if (this.selection[0].payment_type === 'WIRE') {
              payload.report_template = 'payment_receipt_wire_transfer'
            } else if (this.selection[0].payment_type === 'CHECK') {
              payload.report_template = 'default'
            } else if (this.selection[0].payment_type === 'CHECK_MANUAL') {
              payload.report_template = 'payment_receipt_manual_check'
            }
          }
          payload.cached_parameters = resp.id
          const report = await this.$store.dispatch('buildPrintCopyrunPdf', payload)
          this.buildProgress = 100
          this.loadingRelated = false
          setTimeout(() => {
            this.loadPdf = report.data // Set the new PDF data
            this.pdfLoader = true // Open the dialog
          }, 100)
          // if (report && report.data) {
          //   this.checkPdfReady = true
          //   // printJS(this.getCheckrunPdfUrl)
          // } else {
          //   throw new Error('Error generating check PDF.')
          // }
        } catch (e) {
          console.log(e)
          if (!(e instanceof DOMException)) {
            this.$notify({ title: 'Error', message: e.message || 'Error saving checks', type: 'error' })
          }
        }
      },
      /**
       * Post a payment
       * @param payment   The payment to be posted
       */
      async postPayment (payment) {
        try {
          const postPayload = payment.payment_type === 'CHECK' ? checksPayload : payload
          this.postingPayment = payment.id
          const newPayload = Object.assign({}, postPayload, { data: { status: 'POSTED' } }, { id: payment.id })
          const resp = await this.$store.dispatch('update', newPayload)
          if (resp && resp.id) {
            notify(this, 'success', 'Payment posted')
          } else {
            throw new Error()
          }
          return resp
        } catch (e) {
          console.log(e)
          notify(this, 'error', 'Error posting payment')
          return e
        } finally {
          this.postingPayment = null
          const { currentFilters } = this
          this.$store.dispatch('fetchPaymentsWithQuery', currentFilters)
        }
      },
      /**
       * Handles saving a changed status value
       */
      saveChangedStatusValues () {
        this.$store.dispatch('savePc', this.statusValues)
      },
      async handleDeleteDialogVisible () {
        const h = this.$createElement
        this.validationModel = this.$message({
          message: h('p', null, [
            h('span', null, 'Delete this Payment?'),
            h('button', { on: { click: () => this.validationModel.close() }, attrs: { class: 'dialog-button' } }, `Cancel`),
            h('button', { on: { click: () => this.deletePayments() }, attrs: { class: 'dialog-button button-success' } }, `Ok`)
          ]),
          type: 'info',
          duration: 0,
          showClose: true
        })
      },
      /**
       * Gets the related transactions for all payments to be voided. Shows/hides the void payment modal. If visible is
       * a payment object, gets the related transactions for just that payment (rather than all payments in this.selection)
       * and sets this.voidDialogVisible to the payment object so that it can be accessed after the user chooses to void that
       * single payment. Otherwise, voidDialogVisible is simply a boolean.
       * @param visible   Boolean or payment object
       */
      async handleVoidDialogVisible (visible) {
        if (!visible) {
          this.voidDialogVisible = false
          return
        }
        const { selection } = this
        let related
        if (typeof visible === 'object' && visible.related_transactions) {
          related = visible.related_transactions
          this.loadingRelated = visible.id
        } else {
          related = [...new Set([].concat(...selection.map(v => v.related_transactions)))]
          this.loadingRelated = true
        }
        try {
          if (Array.isArray(related) && related.length) {
            let promises = [this.$store.dispatch('fetchApsWithQuery', { query: { id__in: related }, storeLines: false })]
            if (related.length > 20) {                // fetch additional pages if aps > 20
              const reqsNeeded = Math.ceil(related.length / 20)
              for (let i = 2; i <= reqsNeeded; i++) {
                promises.push(this.$store.dispatch('fetchApsWithQuery', { query: { id__in: related, page: i }, storeLines: false }))
              }
            }
            const resp = await Promise.all(promises)
            if (resp && resp.length && resp.every(v => v.entities)) {
              this.relatedTransactions = resp.reduce((a, b) => a.concat(Object.values(b.entities.aps)), [])
            }
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loadingRelated = false
          this.voidDialogVisible = visible
        }
      },
      async deletePayments () {
        let selection = this.selection
        let promises = []
  
        const newPayload = Object.assign({}, payload, { payment_ids: selection.map((payment) => payment.id), ledger_ids: selection.map((payment) => payment.ledger) })
        promises.push(this.$store.dispatch('deletePayment', newPayload))

        this.validationModel.close()

        try {
          const resp = await Promise.all(promises)
          this.selection = []
          if (resp[0].status === 'success') {
            notify(this, 'success', 'Payments deleted')
          } else throw resp[0].body
        } catch (e) {
          console.log(e)
          notify(this, 'error', 'Error deleting payments')
        } finally {
          await this.$store.dispatch('clearPaymentState', true)
          const { currentFilters } = this
          this.$store.dispatch('fetchPaymentsWithQuery', currentFilters)
        }
      },
      /**
       * Handles voiding payments, then resets the selection and related transactions. If this.voidDialogVisible is a payment
       * object rather than a boolean, sets selection to just that payment, and assigns the payment id to this.voidingPayment.
       * Otherwise, selection is assigned the value of this.selection, which is an array of selected payments that should
       * be voided.
       */
      async voidPayments () {
        let selection
        if (typeof this.voidDialogVisible === 'object' && this.voidDialogVisible.id) {
          selection = [this.voidDialogVisible]
          this.voidingPayment = this.voidDialogVisible.id
        } else {
          selection = this.selection
        }
        this.handleVoidDialogVisible(false)
        const { relatedTransactions } = this
        if (!(selection.length && relatedTransactions.length)) return
        let promises = []
        selection.forEach(payment => {
          if (payment.id && payment.id > 0) {
            const newPayload = Object.assign({}, payload, { data: {payment_type: payment.payment_type, is_ap: this.void_ap} }, { id: payment.id })
            promises.push(promises.push(this.$store.dispatch('voidPayment', newPayload)))
          }
        })
        try {
          const resp = await Promise.all(promises)
          this.selection = []
          this.relatedTransactions = []
          if (resp.length === promises.length) {
            notify(this, 'success', (this.void_ap ? 'Payments and selected related transactions voided' : 'Payments voided'))
          }
        } catch (e) {
          console.log(e)
          notify(this, 'error', (this.void_ap ? 'Error voiding payments and related transactions' : 'Error voiding payments'))
        } finally {
          this.voidingPayment = null
          this.void_ap = false
          const { currentFilters } = this
          this.$store.dispatch('fetchPaymentsWithQuery', currentFilters)
        }
      },
      /**
       * Handles transaction selection
       * @param selection
       */
      handleSelectionChange (selection) {
        let notThisPage = this.selection.filter(v => v.page !== this.currentPage)
        this.selection = [...notThisPage, ...selection]
        const duplicatePaymentTypes = [...new Set(selection.map(s => s.payment_type))]
        if (selection && selection.length && duplicatePaymentTypes && duplicatePaymentTypes.length > 1) {
          this.printCopyDisable = true
          return notify(this, 'warning', 'Please select same Payment Type')
        } else {
          this.printCopyDisable = false
        }
        // handleSelectionChange(this, selection)
      },
      /**
       * Preserves the selected transactions and shows them as selected whenever the table is re-rendered
       * due to a page or tab change
       */
      restoreSelection () {
        this.$refs['payments_conf_list'].restoreSelection(this.selection, 'index')
      },
      /**
       * Handles paginating between payment pages
       * @param page  Target page
       */
      async changePage (page) {
        this.changingPage = true
        const { currentFilters } = this
        let newPayload = currentFilters && Object.keys(currentFilters).length
          ? Object.assign({}, payload, { page, query: currentFilters })
          : Object.assign({}, payload, { page })
        try {
          await this.$store.dispatch('clearLocalState', { clearMutation: payload.clearMutation, clearCache: true })
          newPayload.idAttribute = 'index'
          const entities = await this.$store.dispatch('fetchByPage', newPayload)
          await this.$store.commit('UPDATE_CURRENT_PAYMENT_PAGE', page || 1)
          let promises = await this.$store.dispatch('findDependencies', entities)
          await Promise.all(promises)
          this.currentPage = page
          await new Promise((resolve, reject) => {
            setTimeout(() => {
              this.changingPage = false
              resolve()
            })
          })
          this.restoreSelection()
        } catch (e) {
          this.changingPage = false
          console.log(e)
        }
      },
      /**
       * Shows/hides filter pane
       */
      toggleFilters () {
        !this.showFilters ? this.showFilters = true : this.showFilters = false
      },
      /**
       * Formats dollar amounts with thousands separators
       * @param value
       * @return {*}
       */
      formatAmount (value) {
        return value ? formatLocale(value) : ''
      },

      async handleStatusSelection (e) {
        e === 'void' ? await this.handleVoidDialogVisible(true) : e === 'delete' ? await this.handleDeleteDialogVisible(true) : e === 'sendEmail' ? this.handleSelection(0) : ''
        this.voidUpdateSelection = null
      },
  
      async handleSelection (e) {
        if (e === 0) this.sendEmailVisible = true
        const instanceUrl = this.$store.getters.getActiveInstance.url
        const headers = getHeaders(this.$store.getters.getToken)

        await Vue.http.post(buildUrlWithQuery('get_vendors_by_payments', {}, instanceUrl), {payment_ids: this.selection.map((s) => (s.id))}, { headers })
          .then(response => {
            // Check results data is exist or not
            if (response && response.data && response.body.data) {
              this.selectedPayments = response.body.data.map(item => {
                return {
                  attributes: {
                    vendor_id: item.vendor_id,
                    vendor_name: item.vendor_name,
                    email: item.email,
                    routing: item.routing,
                    account: item.account,
                    amount_decimal: item.amount_decimal,
                    payment_confirmation_number: item.payment_confirmation_number,
                    resources: [{attributes: {company_email: item.company_email}}]
                  }
                }
              })
            }
          })
          .catch(error => console(error))
        return
      },

      async sendEmail () {
        try {
          if (!Object.values(this.ccMail).every(mail => mail.attributes.cc_mail)) {
            notify(this, 'error', 'A valid email address must be entered.')
            return
          }
          const payments = this.selection.filter(s => s.payment_type !== 'CHECK').map((ap) => ap.id)
          const checks = this.selection.filter(s => s.payment_type === 'CHECK').map((ap) => ap.id)
          let cc_mails = {}
          this.selectedPayments.forEach((mail) => {
            if (mail.attributes.cc_mail)cc_mails[mail.attributes.vendor_id] = mail.attributes.cc_mail
          })

          const newPayload = Object.assign({}, { payments, checks, cc_mail: cc_mails })
          const resp = await this.$store.dispatch('notifyPayment', newPayload)
          let offset = 0
          if (resp && resp.success.vendors.length) {
            notify(this, 'success', 'Email sent to ' + resp.success.vendors.map((vendor) => vendor.name).join(', '), offset)
          }
          if (resp && resp.error.vendors.length) {
            offset = 100
            notify(this, 'error', 'Unable to send email to ' + resp.error.vendors.map((vendor) => vendor.name).join(', '), offset)
          }
          return resp
        } catch (e) {
          console.log(e)
          notify(this, 'error', 'Error sent email')
          return e
        } finally {
          this.postingPayment = null
          const { currentFilters } = this
          this.$store.dispatch('fetchPaymentsWithQuery', currentFilters)
        }
      },

      handleSelectedConf (selection) {
        this.ccMail = selection
      },
  
      handleCellUpdate (param) {
        if (!param.newValue) {
          notify(this, 'error', 'A valid email address must be entered.')
          return
        }
        let index = this.ccMail.findIndex((mail) => mail.attributes.account === param.data.attributes.account)
        this.ccMail[index].attributes.cc_mail = param.newValue
      },
  
      onClickVendors () {
        this.vendorsDialogVisible = true
      },
      confirmVendors () {
        if (this.selectedVendors && this.selectedVendors.length) {
          this.$store.dispatch('setFilter', { 'vendor__in': this.selectedVendors })
        } else {
          this.$store.dispatch('unsetFilter', 'vendor__in')
        }
        this.vendorsDialogVisible = false
      },
      async allVendors () {
        this.vendorLoading = true
        let response = await this.getAllVendors()
        if (!response || !Array.isArray(response)) return false
        this.vendors = sortObjectByProperty(response, 'code').map((v) => { return { display_name: v.code + ' - ' + v.name, id: v.id } })
        this.vendorLoading = false
      },
      getVendorName (id) {
        if (this.vendors && this.vendors.length) {
          let vendor = this.vendors.find((vendor) => vendor.id === id)
          return vendor.display_name
        }
      }
    },
    computed: {
      ...mapGetters({
        meta: 'getPaymentMetadata',
        currentFilters: 'getFilters',
        getCheckrunPdfUrl: 'getCheckrunPdfUrl',
        receiving: 'getPaymentFetchStatus',
        getApById: 'getApById',
        getBankById: 'getBankById',
        getBatchById: 'getBatchById',
        getVendorById: 'getVendorById',
        getCompanyById: 'getCompanyById',
        getBankByBatchId: 'getBankByBatchId',
        navigating: 'getNavigationStatus'
      }),
      width () {
      // Reducing by 3 % to handle sigma-frontend navbar
        return '100%'
      },
      height () {
      // Reducing by 3 % to handle sigma-frontend navbar
        return window.innerHeight * 0.63 + 'px'
      },
      // disabling print copy option even if 'DRAFT', 'VOIDED', 'DELETED' is selected
      checkingVoid () {
        return this.selection.every(v => !['DRAFT', 'VOIDED', 'DELETED'].includes(v.status))
      },
      selectionIsVoidable () {
        return this.selection.every(v => !['DRAFT', 'VOIDED', 'DELETED'].includes(v.status) && !v.recon)
      },
      selectionIsDeletable () {
        return this.selection.every(v => ['DRAFT'].includes(v.status))
      },
      modelTitle () {
        return this.voidDialogVisible ? 'Void Associated APs' : 'Delete Associated APs'
      },
      payments () {
        return this.$store.getters.getAllCachedPayments
          .filter(v => v.page === this.currentPage)
          // .sort((a, b) => new Date(b.date) - new Date(a.date))
      },
      filters () {
        return [
          {
            type: 'keywordFilter',
            props: {
              styles: '0 4px'
            }
          },
          {
            type: 'selectFilter',
            props: {
              filterName: 'batch__bank',
              clearable: true,
              opts: this.$store.getters.getAllBanks.map(bank => ({ label: bank.name, value: bank.id })),
              multi: true,
              placeholder: 'Bank',
              styles: '0 4px'
            }
          },
          {
            type: 'dateFilter',
            props: {
              filterName: 'date',
              placeholder: 'Payment Start',
              clearable: true,
              styles: '0 4px',
              suffix: 'gte'
            }
          },
          {
            type: 'dateFilter',
            props: {
              filterName: 'date',
              placeholder: 'Payment End',
              clearable: true,
              styles: '0 4px',
              suffix: 'lte'
            }
          },
          {
            type: 'selectFilter',
            props: {
              filterName: 'payment_type',
              clearable: true,
              opts: [
                { label: 'Check', value: 'CHECK' },
                { label: 'EFT', value: 'EFT' },
                { label: 'Manual Check', value: 'CHECK_MANUAL' },
                { label: 'Wire Transfer', value: 'WIRE' }
              ],
              multi: true,
              placeholder: 'Payment Type',
              styles: '0 4px'
            }
          },
          {
            type: 'selectFilter',
            props: {
              filterName: 'is_notified',
              clearable: true,
              opts: [
                { label: 'Sent', value: 'True' },
                { label: 'Unsent', value: 'False' }
              ],
              multi: true,
              placeholder: 'Email Status',
              styles: '0 4px'
            }
          },
          {
            type: 'selectFilter',
            props: {
              filterName: 'status',
              clearable: true,
              opts: [
                { label: 'DRAFT', value: 'DRAFT' },
                { label: 'PRINTED', value: 'POSTED' },
                { label: 'VOIDED', value: 'VOIDED' },
                { label: 'CLOSED', value: 'CLOSED' },
                { label: 'DELETED', value: 'DELETED' }
              ],
              multi: true,
              defaults: [ 'DRAFT', 'POSTED', 'VOIDED', 'CLOSED' ],
              placeholder: 'Status',
              styles: '0 4px'
            }
          }
        ]
      },
      printableApsSelected () {
        return (!!this.selection.length)
      },
      disableSentEmails () {
        return !(this.selection && this.selection.length && !this.selection.filter((s) => ['CHECK', 'CHECK_MANUAL', 'WIRE'].includes(s.payment_type)).length)
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        await store.dispatch('clearLocalState', { clearMutation: payload.clearMutation, clearCache: true })
        payload.idAttribute = 'index'
        const query = { status__in: [ 'DRAFT', 'POSTED', 'VOIDED', 'CLOSED' ] }
        await store.dispatch('setFilter', query)
        const entities = await store.dispatch('fetchPaymentsWithQuery', query)
        const promises = await store.dispatch('findDependencies', entities)
        await Promise.all(promises)
        next()
      } catch (e) {
        console.log(e)
      }
    },
    mounted () {
      const tableHeight = () => {
        const parentHeight = document.getElementById('payments').offsetHeight
        const headerHeight = document.getElementById('payments-header').offsetHeight
        return parentHeight - headerHeight
      }
      this.tableHeight = tableHeight()
    },
    async created () {
      this.allVendors()
    },
    async beforeRouteLeave (to, from, next) {
      this.$store.commit('UPDATE_CURRENT_PAYMENT_PAGE', 1)
      try {
        await Promise.all([
          this.$store.dispatch('clearFilters'),
          this.$store.dispatch('clearApState'),
          this.$store.dispatch('clearPaymentState', true)
        ])
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  #payments-header {
    border-bottom: 1px solid lightgray;
  }
  .el-dialog--large {
    width: 90%;
    height: 150%;
}
  .h-padded {
    padding: 0 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .el-transfer .el-transfer-panel {
    width: 315px !important;
  }
  .vendor-button {
    color: #bfcbd9;
  }
  #payments .el-transfer-panel {
    width: 310px !important;
  }

</style>
<style>
#payments .el-transfer-panel {
    width: 310px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Payments/Payments.vue